import { GetMenu } from 'domain/usecases';
import { loadMenu } from 'presentation/config/store/menu/menu-slice';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

interface IProps {
  getMenu: GetMenu;
}

export const useMenu = ({ getMenu }: IProps) => {
  const dispatch = useDispatch();

  const getMenuItems = useCallback(() => {
    getMenu
      .execute()
      .then((res) => dispatch(loadMenu(res)))
      .catch((err) => console.log(err));
  }, []);

  return {
    getMenuItems,
  };
};
